import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { QuarterlyTaxReceiptModel } from "../quarterly-tax-receipt.model";
import { QuarterlyTaxReceiptConst } from "../quarterly-tax-receipt.conts";
import { Router } from "@angular/router";
import { QuarterlyTaxReceiptService } from "../quarterly-tax-receipt.service";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DummyComponent } from "../../../../shared/dummy.component";
import { DialogsService } from "../../../../shared/components/dialogs/dialogs.service";
import { TableService } from "../../../../shared/components/table/table.service";
import { QuarterlyTaxReceiptDialogDeleteComponent } from "../quarterly-tax-receipt-dialog-delete.component";
import { AccountingManualFormComponent } from "../../../accounting/manual/accounting-manual-form.component";
import { Utils } from "../../../../shared/utils";
import { AddFileService } from '../../../../shared/components/add-file/add-file.service';
import { consts } from "../../../../consts";
import * as FileSaver from 'file-saver';
import { TaxesTabService } from "../../taxes-tabs.service";
import { CoreComponent } from "../../../../core/header/core.component";

@Component({
    selector: 'convfact-quarterly-tax-receipt-list',
    templateUrl: './quarterly-tax-receipt-list.component.html',
    styleUrls: ['./quarterly-tax-receipt-list.component.css'],
    standalone: false
})

export class QuarterlyTaxReceiptListComponent implements OnInit {
  dataSource: QuarterlyTaxReceiptModel[] = [];
  preinvoice: QuarterlyTaxReceiptModel;
  empty: boolean = false;
  image: boolean;
  pdf: boolean;
  ready: boolean = false;
  content = 'list';

  headerTable: any[] = QuarterlyTaxReceiptConst.headerTable;

  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  model = null;

  constructor(
    private router: Router,
    private quarterlyTaxReceiptService: QuarterlyTaxReceiptService,
    private quarterTaxReceiptService: QuarterlyTaxReceiptService,
    private core: CoreComponent,
    private ref: ChangeDetectorRef,
    private addFileService: AddFileService,
    private taxesTabService: TaxesTabService,
    public dialog: MatDialog,
    private AddFileService: AddFileService,
    public dummy: DummyComponent,
    public snackBar: MatSnackBar,
    private dialogsService: DialogsService,
    private tableService: TableService
  ) { }

  //Interaccion con la tabla
  onReceiptNumberClick(justificante) {
    this.downloadFilePdf(justificante.uid);
  }

  onAmountClick(justificante) {
    this.edit(justificante.uid);
  }

  //---------------------------------

  duplicity() {
  }

  public create(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // this.router.navigate(['/taxes/quarter-tax-receipts/create']);
    // this.taxesTabService.onEvent('create-quarterly-tax-receipt');
    this.model = new QuarterlyTaxReceiptModel;
    this.content = 'edit';
    this.initEdit();
  }

  public delete(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(QuarterlyTaxReceiptDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(() => {
        // this.dummy.redirectTo(this.router.url)
        this.getList();
      });
  }

  public edit(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.model = new QuarterlyTaxReceiptModel;
    this.content = 'edit';
    this.quarterlyTaxReceiptService.get(uid).then(quarterlyTaxReceipt => {
      this.model = quarterlyTaxReceipt;
      this.initEdit();
    });
    // this.router.navigate(['/taxes/quarter-tax-receipts/edit/' + uid]);
    // this.taxesTabService.onEvent('update-quarterly-tax-receipt-' + uid);

  }

  ngOnInit() {
    this.dataSource = [];
    this.getList();
  }

  getList() {
    this.quarterlyTaxReceiptService.getList(this.currentPage, this.itemsPerPage).then(
      data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;

        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      });
  }

  pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  public addManualAccountMovements(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog
      .open(AccountingManualFormComponent, {
        width: '60%',
        height: '70%',
        data: {
          accountingMovementId: ''
        }
      })
      .afterClosed().subscribe((result: string) => {
        if (!Utils.IsNullOrEmpty(result)) {
          if (result === 'OK') {
            this.dummy.redirectTo(this.router.url);
          }
        }
      });
  }

  public downloadFilePdf(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.AddFileService.downloadFilePDF(uid, consts.QUARTER_TAX_RECEIPT_ENTITY, consts.EMPTY_GUID).then(response => {
      FileSaver.saveAs(response, Utils.GetPdfName("Justificante"));
    });
  }

  public downloadAll(selected) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.AddFileService.downloadMultiple(consts.QUARTER_TAX_RECEIPT_ENTITY, consts.EMPTY_GUID, selected).then(response => {
      // FileSaver.saveAs(response, Utils.GetPdfName("Justificante"));
      FileSaver.saveAs(response, "justificantes.zip");

    });
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  position = 'above';

  imageTempUrl: any = '';
  pdfTempUrl: any;
  pdfTemp: any;

  result: number;


  originEntity: string = consts.QUARTER_TAX_RECEIPT_ENTITY;
  filePath: string = consts.QUARTER_TAX_RECEIPT_FILE_PATH;

  readOnly: boolean = false;
  hasDuplicateExpense: boolean;

  readyLoadedFiles: boolean = null;

  initEdit() {
    this.ready = true;

    if (this.model.pdf) {
      this.readyLoadedFiles = false;
      this.addFileService.getImageFromFilesPDF(this.model.fileUid, this.originEntity).then(result => {
        this.changeFile(result);
        this.readyLoadedFiles = true;
      });

    } if (this.model.image) {
      this.readyLoadedFiles = false;
      this.addFileService.getImageFromFiles(this.model.fileUid, this.originEntity).then(response => {
        this.createImageFromBlob(response);
        this.readyLoadedFiles = true;
      });
    }
  }

  createImageFromBlob(image: Blob) {
    const reader = new FileReader();
    if (image) {
      reader.readAsDataURL(image);
      reader.onloadend = () => {
        this.imageTempUrl = reader.result;
        this.ref.detectChanges();
      }
      this.ref.detectChanges();
    }
  }

  SetFileParameters(event): void {

    this.model.image = event.Image;
    this.model.pdf = event.PDF;
    this.model.fileUid = event.FileUid;

    if (event.File && event.Image) {
      this.createImageFromBlob(event.File);
    }
    if (event.PDF) {
      this.changeFile(event.File);
    }
  }

  changeFile(data: any) {
    this.imageTempUrl = data;
    this.ref.detectChanges();
  }

  save() {
    let noError = true;

    if (this.model.amount == null || this.model.amount == undefined) {
      noError = false;
      this.displayInfo("Debe especificar importe valido");
    }

    if (this.model.period == null || this.model.period == "" || this.model.period == undefined) {
      noError = false;
      this.displayInfo("Debe especificar periodo valido");
    }

    if (this.model.taxYear == null || this.model.taxYear == undefined) {
      noError = false;
      this.displayInfo("Debe especificar un año valido");
    }

    if (this.model.taxFormModel == null || this.model.taxFormModel == undefined) {
      noError = false;
      this.displayInfo("Debe especificar un modelo válido");
    }

    if (this.model.receiptNumber == null || this.model.receiptNumber == "" || this.model.receiptNumber == undefined) {
      noError = false;
      this.displayInfo("Debe especificar número de justificante valido");
    }

    if (noError) {
      this.quarterTaxReceiptService.saveRequestUpdateValue(true);
      if (this.model.uid == null) {
        this.quarterlyTaxReceiptService.add(this.model)
          .then(quarterlyTaxReceipt => {
            this.model = quarterlyTaxReceipt;
            this.quarterTaxReceiptService.saveRequestUpdateValue(false);
            // this.taxesTabService.onEvent('quarter-tax-receipts');
            this.content = 'list';
            this.getList();
          }).catch(err => {
            this.displayInfo('Ha ocurrido un error inesperado al crear el stock');
            this.quarterTaxReceiptService.saveRequestUpdateValue(false);
          })
      } else {
        this.quarterlyTaxReceiptService.update(this.model)
          .then(quarterlyTaxReceipt => {
            // this.taxesTabService.onEvent('quarter-tax-receipts');
            this.quarterTaxReceiptService.saveRequestUpdateValue(false);
            this.content = 'list';
            this.getList();
          }).catch(err => {
            this.displayInfo('Ha ocurrido un error inesperado al guardar el stock');
            this.quarterTaxReceiptService.saveRequestUpdateValue(false);
          })
      }
      // this.onSave.emit(this.model);
    }
  }

  public trackByIndex(i: number) { return i; }

}
